import { EpubCFI } from 'epubjs';
import * as React from 'react';
import { TextSelectionContext } from '../context/TextSelection';
import { Contents, Section } from '../types/epubs';

export const useEpubTextSelectionEventListeners = (props: {
  window?: Window;
  pageNumber?: number;
  location?: EpubCFI;
  section?: Section;
  contents?: Contents;
}) => {
  const { setEpubSection, setEpubContents } =
    React.useContext(TextSelectionContext);

  React.useEffect(() => {
    const doc = props.window?.document || document;

    const selectionListener = (e: Event) => {
      //for epubs, every toolbar/modal is outside of the document, so we dont need to check whether we should reset the state or not if we have clicked on one of those.
      //for pdf's we want to only reset the state when clicking inside the texylayer, and maintain our selection otherwise.
      const tempSelection = doc.getSelection();
      let epubContainer = undefined;

      if (
        tempSelection &&
        tempSelection?.rangeCount &&
        !tempSelection?.getRangeAt(0)?.collapsed
      ) {
        epubContainer = doc.body as HTMLDivElement;

        if (epubContainer) {
          // const textlayerParent = closestTextLayer.parentElement;
          //const tempPageNumber = textlayerParent.dataset['pageNumber'];
          //setSelection(tempSelection);
          //setContainerElement(epubContainer);
        }
      }

      //setSelecting(false);
    };

    //doc.addEventListener('mousedown', clickListener);
    doc.addEventListener('pointerup', selectionListener);

    return () => {
      // doc.removeEventListener('mousedown', clickListener);
      doc.removeEventListener('pointerup', selectionListener);
    };
  }, [props.window]);

  React.useEffect(() => {
    setEpubSection(props.section);
  }, [props.section]);

  React.useEffect(() => {
    setEpubContents(props.contents);
  }, [props.contents]);
};
